import React from "react"
import {Box, Typography, IconButton} from "@mui/material"
import {Eye, EyeOff} from "lucide-react"

const ShowHideWidget = ({widget, value, onValueChange}) => {
    const handleToggle = () => {
        onValueChange({...value, active: !value.active})
    }

    return (
        <Box
            display="flex"
            alignItems="center"
            justifyContent="space-between"
            border="1px solid #E0E0E0"
            borderRadius="4px"
            px={2}
            py={1}>
            <Typography>{value?.label}</Typography>
            <IconButton
                onClick={handleToggle}
                size="small">
                {value?.active ? <Eye size={20} /> : <EyeOff size={20} />}
            </IconButton>
        </Box>
    )
}

export default ShowHideWidget
